module.exports = __webpack_public_path__ + "static/media/preloader-SMALL-Doma-Pet.cb89932a.gif";